// Where a form field config comes from: the backend's CONFIG_SCOPES
// (services/database/formFields/scopes.js)
export const SCOPES = {
	DEFAULT: 'default',
	LEDGER: 'ledger',
	BROKER_GROUP: 'brokerGroup',
};
